import { Component, Input, SimpleChanges, SimpleChange } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../../../core/abstract-form-component';
import { SettingsHttpService } from '../../../../services/settings/settings.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { SettingsHttpUtil } from '../settings.util';
import { AuthUtil } from '../../../../utils/auth.utils';

@Component({
  moduleId: module.id,
  selector: 'bft-date-settings',
  templateUrl: 'date.settings.component.html'
})
export class DateSettingsComponent extends AbstractFormComponent {

  @Input()
    date;

  @Input()
    display;

  @Input()
    key;

  changeModeStatus: boolean = false;

  constructor(private formBuilder: FormBuilder, private settingsHttpService: SettingsHttpService, private authUtil: AuthUtil) {
    super();
  }

  buildForm(): FormGroup {
    return this.formBuilder.group({
      date: [this.date, [Validators.required]],
    });
  }

  getValidationMessages(): {} {
    return {
      'date': {
        'required': 'Данное поле обязательно для заполнения.',
      },
    };
  }

  submit() {
    if(this.date === this.form.value.date) {
      this.changeModeStatus = false;
      return;
    }

    let data = {
      securityToken: StorageUtil.getToken(),
    };

    data[this.key] = this.form.value.date;

    let requestParams = SettingsHttpUtil.prepareParamsSettings(data);
    this.settingsHttpService.setSettings(requestParams).subscribe(
      success => {
        if (success) {
          this.changeModeStatus = false;
          this.date = this.form.value.date;
          this.authUtil.checkErrorResponse(success.json());
        }
      },
      error => {
        // TODO: validation
        this.formErrors['date'] = 'Введите число.';
      },
      () => {
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    const display: SimpleChange = changes.display;
    if(display.currentValue) {
      this.changeModeStatus = false;
      this.form.setValue({date: this.date});
    }
  }

  toggleChangeStatus($event) {
    $event.preventDefault();

    this.changeModeStatus = true;
  }

  // TODO: move to validation utils or use lib inputMask
  validateDayCount($event) {
    const pattern = /[0-9]/;
    const { key } = $event;
    if (!pattern.test(key)) {
      event.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/settings/date/date.settings.component.ts